<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 5L15.5 12L8.5 19"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
